<p>sale-doc-self-checkout-wrapper-base works!</p>
